import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface ExistingUserParams {
  realm: string;
  userName: string;
}

interface ExistingUserResponse {
  exists: boolean;
}

const fetchExistingUser = async (params: ExistingUserParams): Promise<boolean> => {
  const response = await axios.get<ExistingUserResponse>("/users/existingInKeycloak", {
    baseURL: process.env.REACT_APP_INPUT_CORE,
    params,
  });
  return response.data.exists;
};

export const useCheckExistingUser = (params: ExistingUserParams, options?: any) => {
  return useQuery<boolean>(
    ["existingUser", params.userName],
    () => fetchExistingUser(params),
    {
      enabled: false, 
      retry: false,
      ...options,
    }
  );
};